// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1dd0cea78253a60e4f1e","655":"edefc3c47ead559992c5"}[chunkId] + ".js";
};